import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from "react";
import PropTypes from "prop-types";
import { equals } from "ramda";
import { Flex, TabButton } from "@base-ui";
import handleKeyDown from "./handleKeyDown";
import { extendedSystemStylesProps } from "@mixins";
import { useCustomEffect } from "hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["flexbox", "space", "layout", "color"];
var TabMenu = function TabMenu(props) {
  var id = props.id,
    tabs = props.tabs,
    selected = props.selected,
    updateSelected = props.updateSelected,
    className = props.className,
    inverted = props.inverted;
  var startIdx = tabs.findIndex(function (tab) {
    return tab.id === selected;
  });
  var _useState = useState(startIdx === -1 ? 0 : startIdx),
    _useState2 = _slicedToArray(_useState, 2),
    activeIdx = _useState2[0],
    setActiveIdx = _useState2[1];
  var _handleKeyDown = handleKeyDown(tabs, setActiveIdx),
    onKeyDown = _handleKeyDown.onKeyDown;

  //run updateSelected outside of component whenever activeIdx changes
  useCustomEffect(function () {
    var _tabs$activeIdx, _tabs$startIdx;
    if (!equals((_tabs$activeIdx = tabs[activeIdx]) === null || _tabs$activeIdx === void 0 ? void 0 : _tabs$activeIdx.id, (_tabs$startIdx = tabs[startIdx]) === null || _tabs$startIdx === void 0 ? void 0 : _tabs$startIdx.id)) {
      var _tabs$activeIdx2;
      updateSelected((_tabs$activeIdx2 = tabs[activeIdx]) === null || _tabs$activeIdx2 === void 0 ? void 0 : _tabs$activeIdx2.id);
    }
  }, [activeIdx]);

  //update activeIdx to selected if incoming selected differs from active
  useCustomEffect(function () {
    var newIdx = tabs.findIndex(function (tab) {
      return tab.id === selected;
    });
    if (newIdx !== activeIdx) setActiveIdx(newIdx === -1 ? 0 : newIdx);
  }, [selected]);
  var tabsMarkup = tabs.map(function (tab, idx) {
    return /*#__PURE__*/_jsx(TabButton, {
      id: tab.id,
      role: "tab",
      icon: tab.icon,
      "aria-selected": activeIdx === idx,
      active: activeIdx === idx,
      "aria-controls": "".concat(tab.id, "-panel"),
      onClick: function onClick() {
        return setActiveIdx(idx);
      },
      tabIndex: activeIdx === idx ? 0 : -1,
      inverted: inverted,
      children: tab.label
    }, tab.id);
  });
  return /*#__PURE__*/_jsx(Flex.Row, _objectSpread(_objectSpread({
    id: id,
    className: className,
    role: "tablist",
    onKeyDown: onKeyDown
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: tabsMarkup
  }));
};
TabMenu.propTypes = {
  id: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  selected: PropTypes.string,
  inverted: PropTypes.bool,
  className: PropTypes.string
};
export default TabMenu;